import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getConferenceName } from '../../../base/conference/functions';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            ...withPixelLineHeight(theme.typography.bodyLongRegularLarge),
            color: theme.palette.text01,
            padding: '4px 16px',
            backgroundColor: '#565656',
            maxWidth: 'fit-content',
            boxSizing: 'border-box',
            height: '36px',
            marginLeft: '2px',
            opacity: '0.7',
            '@media (max-width: 300px)': {
                display: 'none'
            },
            '@media only screen and (max-width: $verySmallScreen)': {
                maxWidth: '100%'
            }
        },
        content: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    };
});
/**
 * Label for the conference name.
 *
 * @returns {ReactElement}
 */
const SubjectText = () => {
    const subject = useSelector(getConferenceName);
    const { classes } = useStyles();
    return (
    // <Tooltip
    //     content={subject}
    //     position='bottom'>
    // </Tooltip>
    React.createElement("div", { className: classes.container },
        React.createElement("div", { className: clsx('subject-text--content', classes.content) }, subject)));
};
export default SubjectText;
